import { render, staticRenderFns } from "./CorporateAnnouncementIpoRow.vue?vue&type=template&id=945d6cf6&scoped=true"
import script from "./CorporateAnnouncementIpoRow.vue?vue&type=script&lang=js"
export * from "./CorporateAnnouncementIpoRow.vue?vue&type=script&lang=js"
import style0 from "./CorporateAnnouncementIpoRow.vue?vue&type=style&index=0&id=945d6cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945d6cf6",
  null
  
)

export default component.exports